// 代征平台资料新增/编辑
<template>
  <div class="content">
    <!-- start of title -->
    <div class="title-box">
      <el-button type="default" size="small" @click="$router.go(-1)">返回</el-button>
      <span>编辑资料</span>
    </div>
    <!-- end of title -->

    <el-form :model="formData" :rules="formRules" ref="formData" label-width="150px">
      <!-- start of 基础信息 -->
      <div class="back-color-fff form-box">
        <span class="form-title">基础信息</span>
        <div class="form-item-box">
          <el-row>
            <!-- 公司名称 -->
            <el-col :span="12">
              <el-form-item label="公司名称" :show-message="false" prop="tenantName">
                <el-input
                  clearable
                  placeholder="最多输入50个字"
                  :maxlength="50"
                  @blur="formData.tenantName = $event.target.value.replace(/\s/g, '')"
                  size="small"
                  min="0"
                  v-model="formData.tenantName"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- 公司简称 -->
            <el-col :span="12">
              <el-form-item label="公司简称" :show-message="false" prop="abbreviation">
                <el-input
                  clearable
                  placeholder="最多输入50个字"
                  :maxlength="50"
                  @blur="formData.abbreviation = $event.target.value.replace(/\s/g, '')"
                  size="small"
                  min="0"
                  v-model="formData.abbreviation"
                ></el-input>
              </el-form-item>
            </el-col>

            <!-- 公司成立时间 -->
            <el-col :span="12">
              <el-form-item label="公司成立时间" :show-message="false" prop="levyEnterprise.establishDate">
                <el-date-picker
                  clearable
                  size="small"
                  placeholder="请选择企业创立时间"
                  value-format="yyyy-MM-dd"
                  v-model="formData.levyEnterprise.establishDate"
                ></el-date-picker>
              </el-form-item>
            </el-col>

            <!-- 账号类型 -->
            <el-col :span="12">
              <el-form-item label="账号类型" :show-message="false" prop="memberStatus">
                <el-select clearable size="small" filterable v-model="formData.memberStatus" placeholder="请选择">
                  <el-option
                    v-for="item in getCodeListByKey('账号类型')"
                    :key="item.guid"
                    :label="item.text"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <!-- 公司组织形式 -->
            <el-col :span="12">
              <el-form-item label="公司组织形式" prop="levyEnterprise.organizationForm">
                <el-select
                  size="small"
                  clearable
                  filterable
                  v-model="formData.levyEnterprise.organizationForm"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, index) in getCodeListByKey('公司组织形式')"
                    :key="index"
                    :label="item.text"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <!-- 注册资本(万元) -->
            <el-col :span="12">
              <el-form-item label="注册资本(万元)" :show-message="false" prop="levyEnterprise.registeredCapital">
                <el-input
                  clearable
                  type="text"
                  :maxlength="10"
                  oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                  placeholder="请输入"
                  size="small"
                  min="0"
                  v-model="formData.levyEnterprise.registeredCapital"
                ></el-input>
              </el-form-item>
            </el-col>

            <!-- 证照年审是否正常 -->
            <el-col :span="12">
              <el-form-item label="证照年审是否正常" :show-message="false" prop="levyEnterprise.annualReviewState">
                <el-radio-group v-model="formData.levyEnterprise.annualReviewState">
                  <el-radio label="Y">是</el-radio>
                  <el-radio label="N">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>

            <!-- 是否实缴 -->
            <el-col :span="12">
              <el-form-item label="是否实缴" prop="levyEnterprise.isPaidIn">
                <el-radio-group v-model="formData.levyEnterprise.isPaidIn">
                  <el-radio label="Y">是</el-radio>
                  <el-radio label="N">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>

            <!-- 介绍人 -->
            <el-col :span="12">
              <el-form-item label="介绍人" prop="levyEnterprise.introducer">
                <el-input
                  clearable
                  type="text"
                  @blur="blurName(formData.levyEnterprise.introducer)"
                  :maxlength="10"
                  placeholder="请输入"
                  size="small"
                  v-model="formData.levyEnterprise.introducer"
                ></el-input>
              </el-form-item>
            </el-col>

            <!-- 是否垫资 -->
            <el-col :span="12">
              <el-form-item label="是否垫资" prop="levyEnterprise.isAdvanceMoney">
                <el-radio-group v-model="formData.levyEnterprise.isAdvanceMoney">
                  <el-radio label="Y">是</el-radio>
                  <el-radio label="N">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <!-- 服务费计算方式 -->
            <el-col :span="12">
              <el-form-item label="服务费计算方式"  :show-message="false" prop="levyEnterprise.settleAmountCalculateWay">
                <el-select
                  size="small"
                  clearable
                  filterable
                  v-model="formData.levyEnterprise.settleAmountCalculateWay"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, index) in settleAmountCalculateWayOp"
                    :key="index"
                    :label="item.text"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 联系电话 -->
            <el-col :span="12">
              <el-form-item label="介绍人电话" prop="levyEnterprise.introducerTel">
                <el-input
                  clearable
                  type="text"
                  oninput="value=value.replace(/[^0-9-]/g,'')"
                  :maxlength="20"
                  placeholder="请输入"
                  size="small"
                  v-model="formData.levyEnterprise.introducerTel"
                  @blur="formData.levyEnterprise.introducerTel = $event.target.value"
                ></el-input>
              </el-form-item>
            </el-col>

            <!-- 税号 -->
            <el-col :span="12">
              <el-form-item label="税号" :show-message="false" prop="taxpayerId">
                <el-input
                  clearable
                  type="text"
                  oninput="value=value.replace(/[^0-9a-zA-Z]/g,'')"
                  @blur="formData.taxpayerId = $event.target.value"
                  placeholder="请输入"
                  size="small"
                  v-model="formData.taxpayerId"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- end of 基础信息 -->

      <!-- start of 联系方式 -->
      <div class="back-color-fff form-box">
        <span class="form-title">联系方式</span>
        <div class="form-item-box">
          <el-row>
            <!-- 公司地址 -->
            <el-col :span="12">
              <el-form-item label="公司地址">
                <el-cascader
                  size="small"
                  ref="cascaderFirst"
                  style="width: 314px"
                  @change="incres"
                  :options="options"
                  v-model="addressList"
                  clearable
                  filterable
                >
                </el-cascader>
              </el-form-item>
            </el-col>
            <!-- 详细地址 -->
            <el-col :span="12">
              <el-form-item label="" :show-message="false" prop="address">
                <span slot="label">详细地址 </span>
                <el-input
                  size="small"
                  style="width: 314px"
                  v-model="formData.address"
                  placeholder="请输入详细地址"
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-col>
            <!-- 业务联系人 -->
            <el-col :span="12">
              <el-form-item label="业务联系人" :show-message="false" prop="contacts">
                <el-input
                  @blur="blurName2(formData.contacts)"
                  placeholder="请填写"
                  size="small"
                  type="text"
                  v-model="formData.contacts"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- 联系电话 -->
            <el-col :span="12">
              <el-form-item label="业务联系人电话" :show-message="false" prop="contactTel">
                <el-input
                  clearable
                  type="text"
                  oninput="value=value.replace(/[^0-9-]/g,'')"
                  @blur="formData.contactTel = $event.target.value"
                  :maxlength="20"
                  placeholder="请输入"
                  size="small"
                  v-model="formData.contactTel"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- 公司电话 -->
            <el-col :span="12">
              <el-form-item label="公司电话" :show-message="false" prop="tel">
                <el-input
                  clearable
                  type="text"
                  oninput="value=value.replace(/[^0-9-]/g, '')"
                  @blur="formData.tel = $event.target.value"
                  :maxlength="20"
                  placeholder="请输入"
                  size="small"
                  v-model="formData.tel"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- end of 联系方式 -->

      <!-- start of 证照信息 -->
      <div class="back-color-fff form-box">
        <span class="form-title">证照信息</span>
        <div class="form-item-box">
          <!-- 营业执照 -->
          <el-form-item label="营业执照">
            <div class="file-list-box">
              <el-upload
                class="upload-file-box"
                action="#"
                accept=".jpg,.png,.jpeg,.pdf"
                :limit="1"
                :on-exceed="handleExceed"
                :on-remove="removeBusinessList"
                :http-request="uploadBusinesslicense"
                :file-list="businesslicenseList"
                :beforeUpload="beforeAvatarUpload"
              >
                <div class="import-btn-tips">
                  <el-button size="mini" icon="el-icon-my-import" style="margin-bottom: 0" type="importNew"
                    >上传文件</el-button
                  >
                  <div slot="tip" class="import-step-tip">{{ '注意：支持jpg,png,jpeg,pdf，单个文件大小需 <= 20M' }}</div>
                </div>
              </el-upload>

              <div class="btn-box" v-if="businesslicenseList && businesslicenseList.length > 0">
                <a
                  :href="businesslicenseList[0].path + '?response-content-type=application/octet-stream'"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4"
                  :download="businesslicenseList[0].name"
                  class="downFile"
                  >点击下载</a
                >
                <a
                  @click="seeDetail(businesslicenseList[0].path, businesslicenseList[0].name)"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4; margin-left: 20px"
                  download="FileName"
                  class="downFile"
                  >点击查看</a
                >
                <a
                  @click="handleMainRemove(businesslicenseList[0],'businesslicenseList')"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4; margin-left: 20px"
                  download="FileName"
                  class="downFile"
                  >删除</a
                >
              </div>
            </div>
          </el-form-item>
          <!-- 代征资质 -->
          <el-form-item label="代征资质">
            <div class="file-list-box">
              <el-upload
                class="upload-file-box"
                action="#"
                :limit="1"
                :on-exceed="handleExceed"
                :accept="acceptFile"
                :on-remove="removeAgentList"
                :http-request="uploadAgent"
                :file-list="agentList"
                :beforeUpload="beforeAvatarUpload"
              >
                <div class="import-btn-tips">
                  <el-button size="mini" icon="el-icon-my-import" style="margin-bottom: 0" type="importNew"
                    >上传文件</el-button
                  >
                  <div slot="tip" class="import-step-tip">{{ tips }}</div>
                </div>
              </el-upload>
              <div class="btn-box" v-if="agentList && agentList.length > 0">
                <a
                  :href="agentList[0].path + '?response-content-type=application/octet-stream'"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4"
                  :download="agentList[0].name"
                  class="downFile"
                  >点击下载</a
                >
                <a
                  @click="seeDetail(agentList[0].path, agentList[0].name)"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4; margin-left: 20px"
                  download="FileName"
                  class="downFile"
                  >点击查看</a
                >
                <a
                  @click="handleMainRemove(agentList[0],'agentList')"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4; margin-left: 20px"
                  download="FileName"
                  class="downFile"
                  >删除</a
                >
              </div>
            </div>
          </el-form-item>
          <!-- 完税证明 -->
          <el-form-item label="完税证明" prop="levyEnterprise.taxPaymentCertificateDate">
            <el-select
              size="small"
              clearable
              v-model="formData.levyEnterprise.taxPaymentCertificateDate"
              placeholder="请选择"
            >
              <el-option v-for="(item, index) in monthsList" :key="index" :label="item.text" :value="item.value">
              </el-option>
            </el-select>
            <div class="file-list-box">
              <el-upload
                class="upload-file-box"
                action="#"
                :limit="1"
                :on-exceed="handleExceed"
                :accept="acceptFile"
                :on-remove="removeTaxPaymentList"
                :http-request="uploadTaxPayment"
                :file-list="taxPaymentList"
                :beforeUpload="beforeAvatarUpload"
              >
                <div class="import-btn-tips">
                  <el-button size="mini" icon="el-icon-my-import" style="margin-bottom: 0" type="importNew"
                    >上传文件</el-button
                  >
                  <div slot="tip" class="import-step-tip">{{ tips }}</div>
                </div>
              </el-upload>

              <div class="btn-box" v-if="taxPaymentList && taxPaymentList.length > 0">
                <a
                  :href="taxPaymentList[0].path + '?response-content-type=application/octet-stream'"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4"
                  :download="taxPaymentList[0].name"
                  class="downFile"
                  >点击下载</a
                >
                <a
                  @click="seeDetail(taxPaymentList[0].path, taxPaymentList[0].name)"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4; margin-left: 20px"
                  download="FileName"
                  class="downFile"
                  >点击查看</a
                >
                <a
                  @click="handleMainRemove(taxPaymentList[0],'taxPaymentList')"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4; margin-left: 20px"
                  download="FileName"
                  class="downFile"
                  >删除</a
                >
              </div>
            </div>
          </el-form-item>
          <!-- 个税扣缴明细 -->
          <el-form-item label="个税扣缴明细" prop="levyEnterprise.privateTaxDetailDate">
            <el-select
              size="small"
              clearable
              v-model="formData.levyEnterprise.privateTaxDetailDate"
              placeholder="请选择"
            >
              <el-option v-for="(item, index) in monthsList" :key="index" :label="item.text" :value="item.value">
              </el-option>
            </el-select>
            <div class="file-list-box">
              <el-upload
                class="upload-file-box"
                action="#"
                :limit="1"
                :on-exceed="handleExceed"
                :accept="acceptFile"
                :on-remove="removePrivateTaxList"
                :http-request="uploadPrivateTax"
                :file-list="privateTaxList"
                :beforeUpload="beforeAvatarUpload"
              >
                <div class="import-btn-tips">
                  <el-button size="mini" icon="el-icon-my-import" style="margin-bottom: 0" type="importNew"
                    >上传文件</el-button
                  >
                  <div slot="tip" class="import-step-tip">{{ tips }}</div>
                </div>
              </el-upload>
              <div class="btn-box" v-if="privateTaxList && privateTaxList.length > 0">
                <a
                  :href="privateTaxList[0].path + '?response-content-type=application/octet-stream'"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4"
                  :download="privateTaxList[0].name"
                  class="downFile"
                  >点击下载</a
                >
                <a
                  @click="seeDetail(privateTaxList[0].path, privateTaxList[0].name)"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4; margin-left: 20px"
                  download="FileName"
                  class="downFile"
                  >点击查看</a
                >
                <a
                  @click="handleMainRemove(privateTaxList[0],'privateTaxList')"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4; margin-left: 20px"
                  download="FileName"
                  class="downFile"
                  >删除</a
                >
              </div>
            </div>
          </el-form-item>
          <!-- 是否提供担保 -->
          <el-form-item label="是否提供担保" prop="levyEnterprise.isGuarantee">
            <el-radio-group v-model="formData.levyEnterprise.isGuarantee">
              <el-radio label="Y">可</el-radio>
              <el-radio label="N">不可</el-radio>
            </el-radio-group>
            <div class="file-list-box">
              <el-upload
                class="upload-file-box"
                v-if="formData.levyEnterprise.isGuarantee == 'Y'"
                action="#"
                :limit="1"
                :on-exceed="handleExceed"
                :accept="acceptFile"
                :on-remove="removeIsGuaranteeList"
                :http-request="uploadIsGuarantee"
                :file-list="isGuaranteeList"
                :beforeUpload="beforeAvatarUpload"
              >
                <div class="import-btn-tips">
                  <el-button size="mini" icon="el-icon-my-import" style="margin-bottom: 0" type="importNew"
                    >上传文件</el-button
                  >
                  <div slot="tip" class="import-step-tip">{{ tips }}</div>
                </div>
              </el-upload>
              <div class="btn-box" v-if="isGuaranteeList && isGuaranteeList.length > 0">
                <a
                  :href="isGuaranteeList[0].path + '?response-content-type=application/octet-stream'"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4"
                  :download="isGuaranteeList[0].name"
                  class="downFile"
                  >点击下载</a
                >
                <a
                  @click="seeDetail(isGuaranteeList[0].path, isGuaranteeList[0].name)"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4; margin-left: 20px"
                  download="FileName"
                  class="downFile"
                  >点击查看</a
                >
                <a
                  @click="handleMainRemove(isGuaranteeList[0],'isGuaranteeList')"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4; margin-left: 20px"
                  download="FileName"
                  class="downFile"
                  >删除</a
                >
              </div>
            </div>
          </el-form-item>
        </div>
      </div>
      <!-- end of 证照信息 -->

      <!-- start of 开户行信息 -->
      <div class="back-color-fff form-box">
        <div style="position: relative">
          <span class="form-title">开户行信息</span>
          <el-popover trigger="hover" width="200" placement="top-start">
            <div>{{ '影响下游结算时银行信息选择' }}</div>
            <template slot="reference">
              <i class="el-icon-question"></i>
            </template>
          </el-popover>
          <div class="sub-operate-add2">
            <!-- <el-button type="defalut" size="mini" @click="addBankItem">新增</el-button> -->
          </div>
        </div>
        <div class="form-item-box" v-for="(item, index) in formData.bankList" :key="index">
          <el-row style="padding: 10px 35px">
            <div class="sub-title">
              <span>开户行信息{{ index + 1 }}</span>
              <div style="display: flex">
                <el-button
                  type="defalut"
                  size="mini"
                  v-show="item.guid && item.bizState === 'S'"
                  @click="enableBankItem(item, 'Y')"
                  >启用</el-button
                >
                <el-button
                  type="defalut"
                  size="mini"
                  v-show="item.guid && item.bizState === 'Y'"
                  @click="enableBankItem(item, 'S')"
                  >停用</el-button
                >
                <div style="position: relative">
                  <el-button
                    class="sub-operate-add2"
                    type="defalut"
                    size="mini"
                    v-show="index === 0"
                    @click="addBankItem"
                    >新增</el-button
                  >
                  <el-button type="danger" v-show="formData.bankList.length > 1" size="mini" @click="delBankItem(item,index)">删除</el-button>
                </div>
              </div>
            </div>
          </el-row>

          <el-row>
            <!-- 账户类型-->
            <el-col :span="12">
              <el-form-item label="账户类型" required>
                <el-select size="small" clearable :disabled="item.bizState==='S'" v-model="item.accountType" placeholder="请选择">
                  <el-option
                    v-for="(item, index) in getCodeListByKey('账户类型')"
                    :key="index"
                    :label="item.text"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <!-- 开户银行 -->
            <el-col :span="12">
              <el-form-item label="开户银行" required>
                <el-input
                  type="text"
                  size="small"
                  v-model="item.bankName"
                  :disabled="item.bizState==='S'" 
                  :maxlength="100"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>

            <!-- 开户账号 -->
            <el-col :span="12">
              <el-form-item label="开户账号" required>
                <el-input
                  size="small"
                  type="text"
                  :disabled="item.bizState==='S'" 
                  @input="onInput(index,$event)"
                  @blur="item.bankAccount = $event.target.value"
                  @click.native="checkBankAccount(item,$event)"
                  v-model="item.bankAccount"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>

            <!-- 开户行号 -->
            <el-col :span="12">
              <el-form-item label="开户行号">
                <el-input
                  size="small"
                  type="text"
                  :disabled="item.bizState==='S'" 
                  oninput="value=value.replace(/[^\d\s]/g, '')"
                  @blur="item.bankNo = $event.target.value"
                  v-model="item.bankNo"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- end of 开户行信息 -->

      <!-- start of 开票信息 -->
      <div class="back-color-fff form-box">
        <div style="position: relative">
          <span class="form-title">开票信息</span>
        </div>
        <div class="form-item-box" v-for="(item, index) in formData.bankList" :key="index">
          <el-row style="padding: 10px 35px">
            <div class="sub-title">
              <span>开票信息{{ index + 1 }}</span>
              <div style="display: flex">
                <div style="position: relative">
                  <el-button type="defalut" size="mini" @click="previewInvoice(item)">预览</el-button>
                </div>
              </div>
            </div>
          </el-row>

          <el-row>
            <!-- 发票抬头 -->
            <el-col :span="12">
              <el-form-item label="发票抬头">
                <el-input type="text" disabled size="small" v-model="formData.tenantName" :maxlength="100"></el-input>
              </el-form-item>
            </el-col>

            <!-- 税号 -->
            <el-col :span="12">
              <el-form-item label="税号">
                <el-input size="small" disabled v-model="formData.taxpayerId"> </el-input>
              </el-form-item>
            </el-col>

            <!-- 开户银行 -->
            <el-col :span="12">
              <el-form-item label="开户银行">
                <el-input type="text" size="small" disabled v-model="item.bankName" :maxlength="100"></el-input>
              </el-form-item>
            </el-col>

            <!-- 开户账号 -->
            <el-col :span="12">
              <el-form-item label="开户账号">
                <el-input
                  size="small"
                  disabled
                  type="text"
                  oninput="value=value.replace(/[^\d\s]/g, '')"
                  v-model="item.bankAccount"
                ></el-input>
              </el-form-item>
            </el-col>

            <!-- 电话号码 -->
            <el-col :span="12">
              <el-form-item label="公司电话">
                <el-input
                  size="small"
                  disabled
                  v-model="formData.tel"
                  :maxlength="20"
                >
                </el-input>
              </el-form-item>
            </el-col>

            <!-- 单位地址 -->
            <el-col :span="12">
              <el-form-item label="单位地址">
                <el-input type="text" size="small" disabled style="width: 314px" v-model="formData.address"> </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- end of 开票信息 -->

      <!-- start of 签约合同信息 -->
      <div class="back-color-fff form-box content-main-box" v-if="contractList.length">
        <span class="form-title">签约合同信息</span>
        <div class="back-color-fff form-box">
          <div class="form-item-box">
            <el-table
              ref="multipleTable"
              :data="contractList"
              :max-height="200"
              stripe
              border
              style="width: 100%"
              :row-key="(row) => row.guid"
            >
              <el-table-column label="序号" type="index" width="60" header-align="center" align="center" fixed="left">
              </el-table-column>
              <!-- 合同编号 -->
              <el-table-column
                prop="contractCode"
                min-width="180"
                label="合同编号"
                header-align="center"
                align="left"
                show-overflow-tooltip
              >
              </el-table-column>
              <!-- 合同名称 -->
              <el-table-column
                prop="contractName"
                min-width="180"
                label="合同名称"
                header-align="center"
                align="left"
                show-overflow-tooltip
              >
              </el-table-column>
              <!-- 签约企业 -->
              <el-table-column
                prop="tenantName"
                min-width="210"
                label="签约企业"
                header-align="center"
                align="left"
                show-overflow-tooltip
              >
              </el-table-column>
              <!-- 乙方名称 -->
              <!-- <el-table-column
                prop="serviceTenantName"
                min-width="210"
                label="乙方名称"
                header-align="center"
                align="left"
                show-overflow-tooltip
              >
              </el-table-column> -->
              <!-- 签约日期 -->
              <el-table-column
                prop="signDate"
                min-width="96"
                label="签约日期"
                header-align="center"
                align="left"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{ scope.row.signDate | getDate }}
                </template>
              </el-table-column>
              <!-- 合同有效期 -->
              <el-table-column
                prop="validityDate"
                min-width="96"
                label="合同有效期"
                header-align="center"
                align="left"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span :style="{ color: getAlarmTime(scope.row.validityDate, 30) ? 'red' : '' }">
                    {{ scope.row.validityDate | getDate }}
                  </span>
                </template>
              </el-table-column>
              <!-- 收费比例(%) -->
              <el-table-column
                prop="chargeRate"
                min-width="96"
                label="收费比例(%)"
                header-align="center"
                align="left"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{ Number(scope.row.chargeRate).toFixed('2') }}
                </template>
              </el-table-column>
              <!-- 操作 -->
              <el-table-column
                prop="tenantName"
                min-width="120"
                label="操作"
                fixed="right"
                header-align="center"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <a class="txt-color" @click="openBindingBank(scope.row)">绑定银行账号</a>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <!-- end of 签约合同信息 -->

      <!-- 保存 -->
      <div class="submit-btn-box submit_btn_wrap">
          <el-button type="defalut" size="small" @click="$router.go(-1)">取消</el-button>
          <el-button type="primary" size="small" @click="submitForm()">保存</el-button>
      </div>
    </el-form>
    <!-- 发票信息 -->
    <InvoiceMessage :showInvoiceBox.sync="showInvoiceBox" :invoiceData="invoiceData"></InvoiceMessage>

    <!-- 新增开户行信息弹框 start -->
    <el-dialog title="选择银行账号" :visible.sync="bindBankDialogVisible" width="60%">
      <div class="back-color-fff form-box-add content-main-box">
        <div class="bank-list">
          <el-table
            ref="multipleTable"
            :data="effectiveBank"
            style="width: 100%"
            @selection-change="handleSelectionChange"
            border
            :row-key="(row) => row.guid"
          >
            <el-table-column type="selection" width="60" header-align="center" align="center"></el-table-column>
            <el-table-column prop="bankName" label="开户银行" min-width="210" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="bankAccount" label="开户账号" min-width="210" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="bankNo" label="开户行号" min-width="210" header-align="center" align="center">
              <template slot-scope="scope">
                {{ scope.row.bankNo || '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="accountType" label="账户类型" min-width="96" header-align="center" align="center">
              <template slot-scope="scope">
                {{ $getNameByKey(scope.row.accountType, '账户类型') }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="bottom-btn-box">
          <el-button type="defalut" size="small" @click="bindBankDialogVisible = false">取消</el-button>
          <!-- 新增公司开户行信息 -->
          <el-button type="primary" size="small" @click="confirmBinding()">确定</el-button>
        </div>
      </div>
      <!-- end of 开户行信息 -->
    </el-dialog>
    <!-- 新增开户行信息弹框 end -->
  </div>
</template>

<script>
import areaJson from '../../assets/js/china_address_v4.js';
import InvoiceMessage from './components/invoiceMessage.vue';
export default {
  components: {
    InvoiceMessage,
  },
  data() {
    return {
      enterpriseCate: '9904',
      contractItem: null, // 当前合同信息
      bindBankDialogVisible: false,
      guid: '',
      options: areaJson,
      addressList: [],
      detailAddres: '',
      showInvoiceBox: false, // 预览发票弹框
      invoiceData: {
        invoiceHeader: '',
        taxpayerId: '',
        address_tel: '',
        bankName_acount: '',
      },
      // 表单字段
      formData: {
        tenantName: '', // 企业名称
        abbreviation: '', // 简称
        contractGuid: '', // 合同guid
        levyEnterprise: {
          establishDate: '', // 公司成立时间
          registeredCapital: '', // 注册资本
          organizationForm: '', // 公司组织形式
          isPaidIn: '', // 是否实缴
          annualReviewState: '', // 证照年审状态
          isAdvanceMoney: '', // 是否垫资
          cooperationTaxRate: '', // 服务费率
          costMoney: '', // 服务费
          cooperationValidityDate: '', // 合同有效期至
          monthMaxMoney: '', // 月度合作上限
          invoiceType: '', // 开票类型
          introducer: '', // 介绍人
          serviceType: '', // 服务类型
          introducerTel: '', // 联系电话
          avgServiceCost: '', // 人均服务费
          taxPaymentCertificateDate: '', // 完税证明
          privateTaxDetailDate: '', // 个税扣缴明细
          isGuarantee: '', // 是否提供担保
          settleAmountCalculateWay:null,//服务费计算方式
        },
        contacts: '', // 业务联系人
        contactTel: '', // 业务联系人电话
        expenseType: null, // 后台没接收这个字段，前端用的
        
        taxpayerId: '', // !税号
        tel: '', // !公司电话
        address: '', // !公司地址
        bankList: [
          // !公司的银行列表
          {
            accountType: '',
            bankName: '',
            bankAccount: '',
            bankNo: '',
          },
        ],
      },
      effectiveBank:[], // 启用的银行列表
      
      cooperateBankList:[], // !关联合同的银行list
      selectBank: [], // !勾选的银行
      // 表单验证规则
      formRules: {
        tenantName: [{ required: true, message: '公司名称必填', trigger: 'change' }],
        abbreviation: [{ required: true, message: '公司简称必填', trigger: 'change' }],
        memberStatus: [{ required: true, message: '账号类型必填', trigger: 'change' }],
        contacts: [{ required: true, message: '业务联系人必填', trigger: 'change' }],
        contactTel: [{ required: true, message: '业务联系人电话必填', trigger: 'change' }],
        tel: [{ required: true, message: '公司电话必填', trigger: 'change' }],
        address: [{ required: true, message: '详细地址必填', trigger: 'change' }],
        levyEnterprise:{settleAmountCalculateWay:[{ required: true, message: '服务费计算方式必填', trigger: 'change' }]},
        // 'levyEnterpriseRules.settleAmountCalculateWay':[{ required: true, message: '服务费计算方式必填', trigger: 'change' }],
        taxpayerId: [{ required: true, message: '税号必填', trigger: 'change' }],
        initUserName: [{ required: true, message: '初始账号必填', trigger: 'change' }],
      },
      // levyEnterpriseRules:{
      //     settleAmountCalculateWay:[{ required: true, message: '服务费计算方式必填', trigger: 'change' }],
            
      //   },
      tenantList: [], // 企业下拉选数据
      contractList: [], // 合同下拉选数据
      contractVO: {
        tenantName: '', // 签约企业名称
        tenantGuid: '', // 签约企业guid
      },
      monthsList: [ // 完税证明、个税扣缴明细下拉选数据
        {
          text: '近3个月',
          value: 3,
        },
        {
          text: '近6个月',
          value: 6,
        },
        {
          text: '近12个月',
          value: 12,
        },
      ],
      settleAmountCalculateWayOp: [ // 服务费计算方式下拉选数据
        {
          text: '下发总额*服务费率',
          value: 1,
        },
        {
          text: '每人下发金额*服务费率，四舍五入再求和',
          value: 2,
        },
        {
          text: '每人下发金额*服务费率，向下取两位小数',
          value: 3,
        },
        {
          text: '下发总额*服务费率，向上取两位小数',
          value: 4,
        },
        
      ],
      
      // acceptFile: '.xlsx,.xsl,.xls,.xlsm,.doc,.docx,.png,.jpg,.jpeg,.pdf',
      acceptFile: '*',
      tips: '注意：支持所有文件，单个文件大小需 <= 20M',
      // 营业执照文件
      businesslicenseList: [],
      // 代征资质文件
      agentList: [],
      // 完税证明文件
      taxPaymentList: [],
      // 个人扣缴明细文件
      privateTaxList: [],
      // 是否提供担保文件
      isGuaranteeList: [],
      showImgDialog: false,
    };
  },
  created() {
    // 修改时需要获取详情数据，给表单赋值
    if (this.$route.query.guid) {
      this.guid = this.$route.query.guid;
      this.getDetailDatas(this.guid);
    }
  },
  methods: {
    // 拿到勾选的值
    handleSelectionChange(val) {
      this.selectBank = val;
    },
    // todo 获取企业基础银行列表
    getBankList(callBack) {
      let { tenantGuid } = this.formData;
      let that = this;
      this.api
        .get(`/${serverConfig.msCustomerService}/tenant-expand/levy-enterprise-credential/detail?tenantGuid=${tenantGuid}`)
        .then((res) => {
          const { data } = res;
          if (data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let datas = data.data;
            //开户行信息
            if (datas.bankList && datas.bankList.length) {
              this.$set(this.formData, 'bankList', datas.bankList);
            }
            if (callBack) callBack()
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    // todo 获取企业基础银行列表
    getBankListPromise() {
      let { tenantGuid } = this.formData;
      return new Promise((resolve,reject)=>{
        this.api
          .get(`/${serverConfig.msCustomerService}/tenant-expand/levy-enterprise-credential/detail?tenantGuid=${tenantGuid}`)
          .then((res) => {
            const { data } = res;
            if (data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              let datas = data.data;
              let effectiveBank = []
              //开户行信息
              if (datas.bankList && datas.bankList.length) {
                effectiveBank = datas.bankList.filter(item=>item.bizState === 'Y') // 取启用的银行
              }
              this.effectiveBank = effectiveBank
              resolve(effectiveBank)
            } else {
              this.$message.error(res.data.msg);
              reject(null)
            }
          });
      })
    },
    // todo 获取代征公司关联合同的开户行信息
    getCooperateBankList() {
      let tenantGuid = this.contractItem.serviceTenantGuid; // 代征公司
      let contractGuid = this.contractItem.guid; // 合同的guid
      return new Promise ((resolve,reject)=>{
        this.api
          .get(
            `/${serverConfig.msCustomerService}/tenant-expand/tenant-bank/get-list?tenantGuid=${tenantGuid}&contractGuid=${contractGuid}`,
          )
          .then((res) => {
            const { data } = res;
            if (data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              let datas = data.data;
              //开户行信息
              if (datas && datas.length) {
                datas.forEach((item) => {
                  item.accountTypeName = this.accountTypeFilter(item.accountType);
                });
                this.$set(this, 'cooperateBankList', datas.filter(item=>item.contractGuid));
              } else {
                let bankList = [
                  {
                    //开户行信息
                    accountType: null,
                    bankName: null,
                    bankAccount: null,
                    bankNo: null,
                  },
                ];
                this.$set(this, 'cooperateBankList', []);
              }
              resolve(this.cooperateBankList)
            } else {
              this.$message.error(res.data.msg);
              reject(null)
            }
          });
      })
    },
    // todo 获取代征公司的详情
    getDetailDatas(guid) {
      let that = this;
      let formData = {};
      that.api
        .get(`/${serverConfig.msCustomerService}/tenant-expand/levy-enterprise-credential/detail?tenantGuid=${guid}`)
        .then((resp) => {
          const { data } = resp;
          if (data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let datas = data.data || that.formData;
            let { tenantVO } = datas;
            formData['guid'] = guid;
            formData['tenantGuid'] = datas['tenantGuid'] || tenantVO.guid;
            // 获取合同
            that.getContractData(formData['tenantGuid']);

            formData['tenantName'] = tenantVO['tenantName'];
            formData['enterpriseCate'] = datas['enterpriseCate'];
            formData['contractGuid'] = datas['contractGuid']; // 合同编号
            formData['taxpayerId'] = tenantVO['taxpayerId']; // 税号
            formData['address'] = tenantVO['address']; // 企业地址
            formData['tel'] = tenantVO['tel']; // 公司电话
            formData['province'] = tenantVO['province'];
            formData['city'] = tenantVO['city'];
            formData['district'] = tenantVO['district'];
            formData['memberStatus'] = tenantVO['memberStatus'];

            // 填充地址
            if (!formData['province']) {
              this.addressList = [];
            } else {
              this.addressList = [formData.province, formData.city, formData.district];
            }

            formData['expenseType'] = null;

            formData['levyEnterprise'] = {
              tenantGuid: datas['tenantGuid'] || tenantVO.guid, // 企业guid
              establishDate: datas['establishDate'], // 公司成立时间
              registeredCapital: datas['registeredCapital'], // 注册资本
              organizationForm: datas['organizationForm'], // 公司组织形式
              isPaidIn: datas['isPaidIn'], // 是否实缴
              annualReviewState: datas['annualReviewState'], // 证照年审状态
              isAdvanceMoney: datas['isAdvanceMoney'], // 是否垫资
              cooperationTaxRate: datas['cooperationTaxRate'], // 合作税率
              costMoney: datas['costMoney'], // 固定金额
              cooperationValidityDate: datas['cooperationValidityDate'], // 合同有效期至
              monthMaxMoney: datas['monthMaxMoney'], // 月度合作上限
              invoiceType: datas['invoiceType'] ? datas['invoiceType'].split(',') : null, // 开票类型
              introducer: datas['introducer'], // 介绍人
              serviceType: datas['serviceType'], // 服务类型
              introducerTel: datas['introducerTel'], // 联系电话
              avgServiceCost: datas['avgServiceCost'], // 人均服务费
              taxPaymentCertificateDate: datas['taxPaymentCertificateDate'], // 完税证明
              privateTaxDetailDate: datas['privateTaxDetailDate'], // 个税扣缴明细
              isGuarantee: datas['isGuarantee'], // 是否提供担保
              settleAmountCalculateWay:datas['settleAmountCalculateWay'],
            };

            // 费用类型
            if (datas['cooperationTaxRate'] || datas['cooperationTaxRate'] == 0) {
              formData['expenseType'] = '1';
            }
            if (datas['costMoney'] || datas['costMoney'] == 0) {
              formData['expenseType'] = '2';
            }

            // 企业实体
            if (datas['tenantVO']) {
              formData['abbreviation'] = datas['tenantVO']['abbreviation'];
              formData['contacts'] = datas['tenantVO']['contacts'];
              formData['contactTel'] = datas['tenantVO']['contactTel'];
            }

            // 营业执照文件
            if (datas['businessLicenseUrl']) {
              let file = datas['businessLicenseUrl'].split('/');
              that.businesslicenseList = [
                {
                  name: file[file.length - 1],
                  path: datas['businessLicenseUrl'],
                },
              ];
            }

            // 代征资质文件
            if (datas['qualificationUrl']) {
              let file = datas['qualificationUrl'].split('/');
              that.agentList = [
                {
                  name: file[file.length - 1],
                  path: datas['qualificationUrl'],
                },
              ];
            }

            // 完税证明文件
            if (datas['taxPaymentCertificateUrl']) {
              let file = datas['taxPaymentCertificateUrl'].split('/');
              that.taxPaymentList = [
                {
                  name: file[file.length - 1],
                  path: datas['taxPaymentCertificateUrl'],
                },
              ];
            }

            // 个人扣缴明细文件
            if (datas['privateTaxDetailUrl']) {
              let file = datas['privateTaxDetailUrl'].split('/');
              that.privateTaxList = [
                {
                  name: file[file.length - 1],
                  path: datas['privateTaxDetailUrl'],
                },
              ];
            }

            // 是否提供担保文件
            if (datas['guaranteeUrl']) {
              let file = datas['guaranteeUrl'].split('/');
              that.isGuaranteeList = [
                {
                  name: file[file.length - 1],
                  path: datas['guaranteeUrl'],
                },
              ];
            }

            //开户行信息
            if (datas.bankList && datas.bankList.length) {
              formData.bankList = datas.bankList;
            } else {
              let bankList = [
                {
                  //开户行信息
                  accountType: null,
                  bankName: null,
                  bankAccount: null,
                  bankNo: null,
                },
              ];
              formData.bankList = bankList;
            }

            that.$set(that, 'formData', formData);
            
          }
        });
    },
    /**
     * 更改企业时，需要获取对应的合同数据
     * @param {*} guid
     */
    getContractData(guid) {
      this.api
        .postJson(`/${serverConfig.msCustomerService}/contract/detail-by-tenant-new`, {
          pageIndex: 1,
          pageSize: -1,
          serviceTenantGuid: guid, // 乙方企业GUID
          approveState: 'Y', // U不审批 N审批初始状态 Y已通过 R驳回 C撤销
        })
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            // console.log(res.data)
            this.contractList = res.data.data || [];
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    /**
     * 修改费用类型
     */
    expenseTypeChange(val) {
      // console.log(val)
      if (val == '1') {
        this.formData['levyEnterprise']['costMoney'] = '';
      }
      if (val == '2') {
        this.formData['levyEnterprise']['cooperationTaxRate'] = '';
      }
    },
    /**
     * 提交表单
     */
    submitForm() {
      let that = this;
      let { formData } = this;
      let postData = JSON.parse(JSON.stringify(formData));

      // 开票类型存在数据库是字符串
      if (postData['levyEnterprise'] && postData['levyEnterprise']['invoiceType']) {
        postData['levyEnterprise']['invoiceType'] = postData['levyEnterprise']['invoiceType'].toString();
      }

      // 代征代缴类型
      postData['enterpriseCate'] = this.enterpriseCate;

      // 是否提供担保，如果不提供担保，则将担保附件清空
      if (postData['levyEnterprise'] && postData['levyEnterprise']['isGuarantee'] == 'N') {
        postData['levyEnterprise']['guaranteeUrl'] = '';
      }

      // !开户行信息校验
      if (this.formData.bankList.length > 0) {
        try {
          this.formData.bankList.forEach((item, index) => {
            if (!item.accountType) {
              throw new Error(`开户行信息${index + 1}-账户类型不能为空`);
            }
            if (!item.bankName) {
              throw new Error(`开户行信息${index + 1}-开户银行不能为空`);
            }
            if (!item.bankAccount) {
              throw new Error(`开户行信息${index + 1}-开户账号不能为空`);
            }
          });
        } catch (e) {
          this.$message.error(e.message);
          return;
        }
      }

      let repetitionArr = this.findRepeatBank(); // todo 查找重复的开户账号
      if (repetitionArr.length) {
        let item = repetitionArr[0];
        this.$message.error(`新增开户账号:[${item.bankAccount}]不能重复，请确认!`);
        return;
      }

      this.$refs['formData'].validate((valid, error) => {
        if (valid) {
          if (that.guid) {
            return that.editData(postData);
          }
          that.addData(postData);
        } else {
          if (Object.keys(error) && Object.keys(error).length) {
            Object.keys(error).forEach((item, index) => {
              if (error[item] && error[item][0] && index === 0) {
                let errorItem = error[item][0];
                this.$message.error(errorItem.message);
              }
            });
          }
          console.log('error submit!!');
          return false;
        }
      });
    },
    addData(postData) {
      this.api
        .postJson(`/${serverConfig.msCustomerService}/tenant-expand/levy-enterprise-credential/add`, postData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message.success('保存成功');
            this.$router.go(-1);
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    editData(postData) {
      let that = this;
      that.api
        .put(`/${serverConfig.msCustomerService}/tenant-expand/levy-enterprise-credential/update`, postData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            that.$message.success('保存成功');
            this.$router.go(-1);
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    /**
     * 上传营业执照文件-导入
     */
    uploadBusinesslicense(file) {
      let self = this;
      self.uploadData(file, function (status, res) {
        console.log(status);
        // status 1上传成功  2上传失败
        if (status == 1) {
          self.businesslicenseList.push({
            name: file.file.name,
            path: res.data.data.data,
          });
          // 营业执照路径赋值
          self.formData.levyEnterprise['businessLicenseUrl'] = res.data.data.data;
          return;
        }
        if (status == 2) {
          self.removeBusinessList();
        }
      });
    },
    /**
     * 上传代征资质文件-导入
     */
    uploadAgent(file) {
      let self = this;
      self.uploadData(file, function (status, res) {
        // status 1上传成功  2上传失败
        if (status == 1) {
          self.agentList.push({
            name: file.file.name,
            path: res.data.data.data,
          });
          // 代征资质路径赋值
          self.formData.levyEnterprise['qualificationUrl'] = res.data.data.data;
        }
        if (status == 2) {
          self.removeAgentList();
        }
      });
    },
    /**
     * 上传完税证明文件-导入
     */
    uploadTaxPayment(file) {
      let self = this;
      self.uploadData(file, function (status, res) {
        // status 1上传成功  2上传失败
        if (status == 1) {
          self.taxPaymentList.push({
            name: file.file.name,
            path: res.data.data.data,
          });
          // 完税证明路径赋值
          self.formData.levyEnterprise['taxPaymentCertificateUrl'] = res.data.data.data;
        }
        if (status == 2) {
          self.removeTaxPaymentList();
        }
      });
    },
    /**
     * 上传个人扣缴明细文件-导入
     */
    uploadPrivateTax(file) {
      let self = this;
      self.uploadData(file, function (status, res) {
        // status 1上传成功  2上传失败
        if (status == 1) {
          self.privateTaxList.push({
            name: file.file.name,
            path: res.data.data.data,
          });
          // 个人扣缴明细路径赋值
          self.formData.levyEnterprise['privateTaxDetailUrl'] = res.data.data.data;
        }
        if (status == 2) {
          self.removePrivateTaxList();
        }
      });
    },
    /**
     * 上传是否提供承担文件-导入
     */
    uploadIsGuarantee(file) {
      let self = this;
      self.uploadData(file, function (status, res) {
        // status 1上传成功  2上传失败
        if (status == 1) {
          self.isGuaranteeList.push({
            name: file.file.name,
            path: res.data.data.data,
          });
          // 承担文件路径赋值
          self.formData.levyEnterprise['guaranteeUrl'] = res.data.data.data;
        }
        if (status == 2) {
          self.removeIsGuaranteeList();
        }
      });
    },
    /**
     * 附件上传方法
     * @param {*} file
     * @param {*} fn
     */
    uploadData(file, fn) {
      let self = this;
      console.log(file);
      let formData = new FormData();
      formData.append('file', file.file);
      formData.append('fileName', file.file.name);
      self.api
        .postImage(`/${serverConfig.msCommonAdminCloudService}/obs/upload-file-include-filename`, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            // 成功回调
            if (fn) fn(1, res);
            self.$message({
              message: '上传成功',
              type: 'success',
            });
          } else {
            // 失败回调
            if (fn) fn(2, res);
            self.$message.error('上传失败!');
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    /**
     * 移除营业执照文件
     */
    removeBusinessList() {
      this.businesslicenseList = [];
      this.formData.levyEnterprise['businessLicenseUrl'] = '';
    },
    /**
     * 移除代征资质文件
     */
    removeAgentList() {
      this.agentList = [];
      this.formData.levyEnterprise['qualificationUrl'] = '';
    },
    /**
     * 移除完税证明文件
     */
    removeTaxPaymentList() {
      this.taxPaymentList = [];
      this.formData.levyEnterprise['taxPaymentCertificateUrl'] = '';
    },
    /**
     * 移除个人扣缴明细文件
     */
    removePrivateTaxList() {
      this.privateTaxList = [];
      this.formData.levyEnterprise['privateTaxDetailUrl'] = '';
    },
    /**
     * 移除是否提供承担文件
     */
    removeIsGuaranteeList() {
      this.isGuaranteeList = [];
      this.formData.levyEnterprise['guaranteeUrl'] = '';
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件`);
    },
    /**
     * 上传前校验
     */
    beforeAvatarUpload(file) {
      var fileSuffix = file.name ? file.name.substring(file.name.lastIndexOf('.') + 1) : '';
      const isJPG =
        fileSuffix === 'xlsx' ||
        fileSuffix === 'xsl' ||
        fileSuffix === 'xls' ||
        fileSuffix === 'xlsm' ||
        fileSuffix === 'doc' ||
        fileSuffix === 'docx' ||
        fileSuffix === 'png' ||
        fileSuffix === 'jpeg' ||
        fileSuffix === 'jpg' ||
        fileSuffix === 'pdf';

      const isLt5M = file.size / 1024 / 1024 < 20;
      // if (!isJPG) {
      //   this.$message.error('文件格式不正确!');
      // }
      if (!isLt5M) {
        this.$message.error('文件大小不能超过20MB!');
      }
      return isJPG && isLt5M;
    },
    /**
     * 查看文件
     * @param {*} url
     * @param {*} name 图片名称
     */
    seeDetail(url, name) {
      var fileSuffix = name ? name.substring(name.lastIndexOf('.') + 1) : '';
      if (fileSuffix === 'png' || fileSuffix === 'jpeg' || fileSuffix === 'jpg' || fileSuffix === 'pdf') {
        return window.open(url, name);
      }
      window.open('https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(url));
    },
    //新增基础开户行信息
    addBankItem() {
      this.formData.bankList.push({
        accountType: null,
        bankName: null,
        bankAccount: null,
        bankNo: null,
      });
    },
    //删除银行
    delBankItem(item,index) {
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        if(item.guid){
          this.tableLoading = true;
          this.api.postJson(`/ms-customer-service/tenant-expand/tenant-bank/delete?guid=${item.guid}&enterpriseCate=${this.enterpriseCate}`).then((res) => {
            this.tableLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              this.$message.success('删除成功');
              this.getBankList()
            } else {
              this.$message.error(res.data.msg);
            }
          });
        }else{
          this.formData['bankList'].splice(index, 1);
        }
      });
    },
    // todo 合同信息绑定银行账号
    confirmBinding() {
      let arr = []
      if (!this.selectBank.length) {
         this.$message.warning('请勾选开户行信息');
         return
      }
      this.selectBank.forEach(item=>{
        arr.push({
          tenantGuid:this.contractItem.serviceTenantGuid,
          tenantName:this.contractItem.serviceTenantName,
          contractGuid:this.contractItem.guid,
          bankName:item.bankName,
          bankAccount:item.bankAccount,
          bankNo:item.bankNo,
          bankTaxNo:this.formData.taxpayerId,
        })
      })
      this.api
        .postJson(
          `/${serverConfig.msCustomerService}/tenant-expand/tenant-bank/add-contract-bank`,
          arr,
        )
        .then((res) => {
          const { data } = res;
          if (data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message.success('绑定成功');
            this.bindBankDialogVisible = false;
            this.getContractData(this.formData.tenantGuid) // 刷新合同
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    // todo 打开开户行信息弹框 contractItem合同信息
    async openBindingBank(contractItem) {
      console.time()
      this.contractItem = contractItem;
      this.bindBankDialogVisible = true;
      Promise.all([this.getBankListPromise(),this.getCooperateBankList()]).then(([baseBankListRes,cooperateBankListRes])=>{
        let baseBankList = baseBankListRes
        let cooperateBankList = cooperateBankListRes
        if (Array.isArray(cooperateBankList) && Array.isArray(baseBankList)) {
            this.$nextTick(()=>{
              let arr = []
              // 匹配勾选的开户行信息
              cooperateBankList.forEach(selectItem=>{
                baseBankList.forEach(bankItem=>{
                  if (selectItem.guid === bankItem.guid) {
                    arr.push(bankItem)
                  }
                })
              })
              arr.forEach(item=>{
                this.$refs.multipleTable.toggleRowSelection(item);
              })
            })
          }
      })
      console.timeEnd()
    },
    addressChange(val) {
      if (val && val.length) {
        this.formData.address = `${val.join('')}${this.formData.address || ''}`;
      }
    },
    checkPhone(value) {
      let { formData } = this;
      if (/^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/.test(value)) {
        formData.tel = value;
      } else {
        formData.tel = '';
      }
    },
    accountTypeFilter(val) {
      if (!val) {
        return '-';
      }
      switch (val) {
        case '1':
          return '基本户';
        case '2':
          return '一般户';
        case '3':
          return '开票户';
        case '4':
          return '打款户';
      }
    },
    incres(area) {
      this.formData.province = area[0];
      this.formData.city = area[1];
      this.formData.district = area[2];
      let venue = '';
      if (area) {
        if (area[0]) {
          venue = this.province(area[0]);
        }
        if (area[1]) {
          venue = this.province(area[0]) + '/' + this.city(area[1]);
        }
        if (area[2]) {
          venue = this.province(area[0]) + '/' + this.city(area[1]) + '/' + this.district(area[2]);
        }
      }
      this.formData.venue = venue;
    },
    province(val) {
      let pr = '';
      this.options.forEach(function (j) {
        if (j.value == val) {
          pr = j.label;
        }
      });
      return pr;
    },
    city(val) {
      let ci = '';
      this.options.forEach(function (i) {
        if (i.children != null && i.children != '') {
          i.children.forEach(function (j) {
            if (j.value == val) {
              ci = j.label;
            }
          });
        }
      });
      return ci;
    },
    district(val) {
      let di = '';
      this.options.forEach(function (i) {
        if (i.children != null && i.children != '') {
          i.children.forEach(function (j) {
            if (j.children != null && j.children != '') {
              j.children.forEach(function (n) {
                if (n.value == val) {
                  di = n.label;
                }
              });
            }
          });
        }
      });
      return di;
    },
    /**
     *
     * 判断是否在某个时间点内
     * date 输入日期(new Date())
     * dayNum 天数
     */
    getAlarmTime(date, dayNum) {
      let flag = false;
      let contractTime = new Date(date).getTime();
      let currentTime = new Date().getTime();
      let alarmTime = dayNum * 1000 * 24 * 60 * 60;
      if (contractTime - currentTime <= alarmTime) {
        flag = true;
      } else {
        flag = false;
      }
      return flag;
    },
    // 开户行信息启用/停用
    enableBankItem(item, type) {
      if (!item.guid) this.$message.error(`开户行信息不存在`);
      let req = {
        bizState: type,
        guid: item.guid,
      };
      this.fullscreenLoading = true;
      this.api
        .put(`/ms-customer-service/tenant-expand/tenant-bank/update-state?bizState=${type}&guid=${item.guid}`)
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message.success('修改成功');
            this.getBankList();
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    // 预览发票
    previewInvoice(item) {
      this.showInvoiceBox = true;
      this.invoiceData.invoiceHeader = this.formData.tenantName;
      this.invoiceData.taxpayerId = this.formData.taxpayerId;
      this.invoiceData.address_tel = `${this.formData.address} ${this.formData.tel}`;
      this.invoiceData.bankName_acount = `${item.bankName} ${item.bankAccount}`;
    },
     // todo 查找重复的银行
    findRepeatBank() {
      let deWeightArr = []; // 去重后的数组
      let repetitionArr = []; // 重复的数组
      this.formData.bankList.forEach((item1) => {
        const check = deWeightArr.every((item2) => {
          return item1.bankAccount !== item2.bankAccount;
        });
        check ? deWeightArr.push(item1) : repetitionArr.push(item1);
      });
      console.log('重复的数据================>>>>>', repetitionArr);
      return repetitionArr;
    },
    handleMainRemove(file,key) {
      this[key].forEach((item, index) => {
        if (item.path == file.path) {
          this[key].splice(index, 1);
        }
      });
    },
    blurName(value) {
      this.formData.levyEnterprise.introducer = this.$NameCheckBlur(this, value);
    },
    blurName2(value) {
      this.formData.contacts= this.$NameCheckBlur(this, value);
    },
     // 银行卡校验提醒
    checkBankAccount(item,$event) {
      if (item.bankAccount && item.guid) {
        this.api.get(`/${serverConfig.msCustomerService}/tenant-expand/tenant-bank/is-update?guid=${item.guid}&enterpriseCate=${this.enterpriseCate}`).then((res) => {
          if (res.data.code === '0000') {
              if (res.data.msg) {
                this.$confirm(res.data.msg, '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning',
                }).then(() => {});
              }
            }
        });
      }
    },
    // 开户账号校验
    onInput(idx,event) { 
      const newValue = event; 
      const numericValue = newValue.replace(/\D/g, ''); // 仅保留数字 
      // 检查输入是否包含非数字字符 
      if (newValue !== numericValue) { 
        // 如果有非数字字符，则更新输入框的值为仅包含数字的值
        this.$set(this.formData.bankList[idx],'bankAccount',numericValue)
        //  this.inputValue = numericValue; 
        } else { 
          // 如果输入内容只包含数字，则保持输入框的当前值不变 
          this.$set(this.formData.bankList[idx],'bankAccount',newValue)
          // this.inputValue = newValue; 
        } 
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  padding: 0px;
  margin: 0px;
  padding-bottom: 60px;
  .title-box {
    border-top: 1px solid #e5e5e5;
    background-color: #ffffff;
    padding: 8px 0px;
    position: relative;
    button {
      font-size: 12px;
      color: #212121;
      letter-spacing: 0;
      width: 60px;
      height: 26px;
      padding: 0px;
      border: 1px solid rgba(217, 217, 217, 1);
      border-radius: 2px;
      position: absolute;
      left: 16px;
      top: 6px;
    }
    span {
      text-align: center;
      font-size: 16px;
      font-weight: 400;
    }
  }
  .form-box {
    margin-top: 4px;
    text-align: left;

    .form-box-title {
      display: flex;
      justify-content: space-between;
    }
    .form-title {
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      margin-left: 16px;
    }
    .form-item-box {
      width: 90%;
      margin: 0 auto;
      padding-bottom: 15px;
    }
    // .el-col-12 {
    //   height: 50px;
    // }
    .el-form-item {
      margin-bottom: 0px;
    }
    .el-input,
    .el-select {
      width: 314px;
    }
    .age-are-box {
      display: flex;
      align-items: center;
      .el-input {
        width: 142px;
      }
      span {
        margin: 0px 8px;
      }
    }
    .bottom-btn-box {
      padding: 18px 0px;
      text-align: center;
      border-top: 1px solid #e5e5e5;
    }
  }

  .form-box-add {
    margin-top: 4px;
    text-align: left;

    .form-title {
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      margin-left: 16px;
    }
    .bank-list {
      max-height: 500px;
      overflow-y: auto;
    }
    .form-item-box {
      width: 90%;
      margin: 0 auto;
    }
    // .el-col-12 {
    //   height: 50px;
    // }
    .el-form-item {
      margin-bottom: 8px;
    }
    .el-input,
    .el-select {
      width: 314px;
    }
    .age-are-box {
      display: flex;
      align-items: center;
      .el-input {
        width: 142px;
      }
      span {
        margin: 0px 8px;
      }
    }
    .bottom-btn-box {
      padding: 18px 0px;
      text-align: center;
      border-top: 1px solid #e5e5e5;
    }
  }

  /deep/ .el-form-item__error {
    padding-top: 0px;
  }
  .el-button--primary {
    color: #ffffff;
  }

  .file-list-box {
    display: flex;
    // justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 32px;
    .upload-file-box {
      max-width: calc(100% - 132px - 16px);
    }
    .btn-box {
      position: absolute;
      width: 180px;
      margin-left: 16px;
      height: 32px;
      left:430px
    }
  }
  .sub-title {
    line-height: 28px;
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .sub-operate-add {
    color: #4fa1a4;
    margin-left: 14px;
    cursor: pointer;
  }
  .sub-operate-add2 {
    position: absolute;
    right: 0px;
    top: -35px;
  }
}
/deep/ .el-upload__tip {
  line-height: 1;
  margin-top: 8px;
}
/deep/ .el-upload-list__item:first-child {
  margin-top: 8px;
}
.content-main-box {
  height: 100%;
  max-height: 300px;
}
.sub-operate-add3 {
  position: absolute;
  right: 30px;
  top: 5px;
}
/deep/ .el-upload-list__item {
  // width
  width: 430px;
}
</style>
